import { element } from 'protractor';
import { Branch } from 'src/app/models/Branch';
import { position } from 'src/app/models/position';
import { Component, ViewChild, OnInit, Input, OnDestroy } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { SearchService } from 'src/app/services/search.service';
import "../../../../assets/js/theme";
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { faMapMarkerAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';


@Component({
  selector: 'googlemappage',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.css']
})
export class GoogleMapComponent implements OnInit,OnDestroy {
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  lat = 51.678418;
  lng = 7.809007;
  center = { lat: 24, lng: 12 };
  markerOptions = { draggable: false };
  markerPositions: google.maps.LatLngLiteral[] = [];
  zoom = 9;
  display?: google.maps.LatLngLiteral;
  branches: any;
  currentSelectedLocation: position;
  iconUrl: any;
  icon: any;
  previousInfoWindow;
  openedWindow: string;
  faMapMarkerAlt=faMapMarkerAlt;
  searchModel:VehicleReservationSearchParm;
  currency;

  subscriptions:Subscription[]=[];

  constructor( private searchService: SearchService,private router: Router) {
    this.iconUrl = this.searchService.svgToUrlImage('50', 1);
    this.icon = {
      labelOrigin: { x: 16, y: 48 },
      url: this.iconUrl,
      scaledSize: {
        width: 32,
        height: 32
      }
    };
    this.currency=this.searchService.getCurrency();

    //var url=this.searchService.svgToUrlImage2('10');

  }

  addMarker(event: google.maps.MouseEvent) {
    this.markerPositions.push(event.latLng.toJSON());
  }

  move(event: google.maps.MouseEvent) {
    this.display = event.latLng.toJSON();
  }

  openInfoWindow(marker: MapMarker) {
    this.infoWindow.open(marker);
  }

  removeLastMarker() {
    this.markerPositions.pop();
  }

 /*  markerClicked(branch) {
    this.searchService.updateSelectedLocation({ lat: branch.position.lat, lng: branch.position.lng });

  } */
  ngOnInit() {

    //To Navigate to the current UserLocation
  /*   navigator.geolocation.getCurrentPosition(position => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
    }) */
    this.subscriptions.push(this.searchService.searchModel.subscribe(res =>{
      this.searchModel=res;
    }));
    this.center={
      lat: this.searchModel.Latitude,
      lng: this.searchModel.Longitude
    }
    this.subscriptions.push(this.searchService.branches.subscribe(res=>{
      //IF the page refreshed and cached
      if((res==null || res.length==0)&& this.searchModel!=null&&this.searchModel.AgencyID!=null){
        this.subscriptions.push(this.searchService.VehicleReservationSearch(this.searchModel).subscribe(res => {
          if(res!=null){
            var branchList=this.searchService.vehicleReservationResultToBranch(res.lstVehicleReservationSearchResultModel);
            //Update the Branch Store by load the new branch list
           // this.searchService.loadBranchList(branchList.filter(branch => branch.agencyID==this.searchModel.AgencyID));
          }else{
            this.router.navigate(['/home']);
          }

        }));
      }
      this.branches = res
    }));

    this.subscriptions.push(this.searchService.currentOpenInfoWindow
      .subscribe(res => this.openedWindow = res));


    //this.searchService.loadAll();

    //this.searchService.currentPos.subscribe(res => this.currentSelectedLocation=res);


 

  }
  revokeURL(url) {

    //URL.revokeObjectURL(url);
  }

  onMarkerMouseOver(branch: Branch) {

    branch.isHovered = true;
    branch.icon = branch.iconUrl2;
    this.searchService.update(branch);

    //document.querySelector('.active').scrollIntoView();




    const itemToScrollTo = document.getElementById('branch-' + branch.id);
    // null check to ensure that the element actually exists
    if (itemToScrollTo) {
     // itemToScrollTo.scrollIntoView(true);
    }

  }
  onMarkerMouseOut(branch: Branch) {
    branch.isHovered = false;
    branch.icon = branch.iconUrl1;
    //Update the Search Store
    this.searchService.update(branch);
  }


  //Handle Mulltiple agm-info-window displayed at once
  onMarkerClicked(infowindow) {


    var el = document.getElementsByClassName('gm-ui-hover-effect');
    for (var i = 0; i < el.length; i++) {
      var element=el[i] as HTMLElement;
      element.click();
    }

    if (this.previousInfoWindow) {
      this.previousInfoWindow.close();
    }

    this.previousInfoWindow = infowindow;
  }



  //To Show/Hide  agm-info-window based on the ID
  //If this.openedWindow changed to specifc ID that exist in the Map it will Show It.
  isInfoWindowOpen(id) {
    return this.openedWindow == id;
  }

  onShowAllCarsClicked(branch: Branch){
    this.searchService.openInfoWindow(-1);
    this.searchService.setSelectedBranch(branch);
    let tmp=this.searchModel;
    tmp['AgencyID']=branch.agencyID;
    tmp['FromAgencyName'] = branch.name;
    tmp.PageNumber = 1;

    this.searchService.updateSearchModel(tmp);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item =>{
      item.unsubscribe();
    })
  }

}
